import { useEffect, useRef, useState } from "react";
import { systemPrompt } from "./chatComponents/prompt";
import { sendMessage } from "./utility/sendMessage";
import { Box, Button, Divider, Typography } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate } from "react-router-dom";
import { MessageInputContainer } from "./chatComponents/MessageInputContainer";
import { MessageViewContainer } from "./chatComponents/MessageViewContainer";
import { useAuth } from "../context/AuthContext";
import { assistantWithCreateThread } from "./utility/assistantWithCreateThread";
import { assistantContinueConversation } from "./utility/assistantContinueConversation";
import { SelectBotDialog } from "./chatComponents/SelectBotDialog";
import { PreparationComponent } from "./chatComponents/PreparationComponent";

interface messageData {
  content: string;
  role: string;
}

type assistantType = {
  name: string;
  instructions: string;
  id: string;
};

export const FreeChatPageC = () => {
  const navigate = useNavigate();
  const { idToken, refreshAuthSession } = useAuth();
  const [conversationData, setConversationData] = useState<messageData[]>([]);
  const [threadId, setThreadId] = useState<string>("");
  const [appliedAssistant, setAppliedAssistant] =
    useState<assistantType | null>(null);

  const [botSelectDialogIsOn, setBotSelectDialogIsOn] =
    useState<boolean>(false);

  const [preparationComplete, setPreparationComplete] =
    useState<boolean>(false);

  const bottomRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setConversationData([]);
    // 会話データのほうの処理
    // createFirstMessage();
    if (idToken) {
      assistantWithCreateThread(idToken, appliedAssistant?.id).then((data) => {
        setThreadId(data.threadId);
        const receivedMessage: messageData = {
          role: "assistant",
          content: data.messages[0].content[0].text.value,
        };
        setConversationData([receivedMessage]);
        setPreparationComplete(true);
      });
    }
  }, [appliedAssistant]);

  // とりあえず仮で置くが、どこか上位（App.tsxなど）に設置
  useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    setVh();
    window.addEventListener("resize", setVh);
    return () => window.removeEventListener("resize", setVh);
  }, []);

  // メッセージ送信処理実行
  const sendAndReceiveMessage = (input: string) => {
    // setInput("");
    const newMessage = {
      role: "user",
      content: input,
    };
    setConversationData((prevMessage) => [...prevMessage, newMessage]);
    // 会話データ更新の度に画面を最下部にスクロール
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });

    if (!idToken) return;
    if (!threadId) return;

    assistantContinueConversation(
      idToken,
      input,
      threadId,
      appliedAssistant?.id
    ).then((data) => {
      const receivedMessage: messageData = {
        role: "assistant",
        content: data.allMessages[0].content[0].text.value,
      };
      setConversationData((prevMessage) => [...prevMessage, receivedMessage]);
    });

    // sendMessage(messageForSend, idToken).then(
    //   (receivedMessage: messageData) => {
    //     if (receivedMessage.role === "error") {
    //       //
    //       // エラー処理を後で追加する
    //       //
    //     }
    //     //
    //     setConversationData((prevMessage) => [...prevMessage, receivedMessage]);
    //     // 会話データ更新の度に画面を最下部にスクロール
    //     window.scrollTo({
    //       top: document.body.scrollHeight,
    //       behavior: "smooth",
    //     });
    //   }
    // );
  };

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [conversationData]);

  if (!preparationComplete) return <PreparationComponent />;

  return (
    <Box
      sx={{
        // height: "100svh",
        position: "relative",
        // height: "100vh",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* ヘッダー */}
      <Box sx={{ textAlign: "center", py: 1 }}>
        <Typography variant="caption">
          開発用のモードです。データは保存されません。
        </Typography>
      </Box>

      <Divider />

      {/* 戻るボタン */}
      <Box sx={{ p: 1 }}>
        <Button onClick={() => navigate("/")}>
          <ArrowBackIosIcon fontSize="small" />
          戻る
        </Button>
      </Box>

      {/* チャットエリア */}

      {/* メッセージリスト */}
      <MessageViewContainer
        conversationData={conversationData}
        bottomRef={bottomRef}
      />

      {/* 入力欄 */}
      <MessageInputContainer sendAndReceiveMessage={sendAndReceiveMessage} />

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 1,
        }}
      >
        <Typography sx={{ mr: 2 }}>
          {appliedAssistant?.name || "Active-Constructive(default)"}
        </Typography>
        <Button variant="outlined" onClick={() => setBotSelectDialogIsOn(true)}>
          BOTの変更
        </Button>
      </Box>

      <SelectBotDialog
        isOpen={botSelectDialogIsOn}
        setIsOpen={setBotSelectDialogIsOn}
        applyAssistant={setAppliedAssistant}
      />
    </Box>
  );
};
